const ChevronDown = ({ handleChatToggle }) => {
  return (
    <button
      onClick={handleChatToggle}
      title="Collapse Chat Window"
      id="curatu-minimize-chat"
      className="hover:curai-ring-1 hover:curai-ring-white focus:curai-box-border curai-border-none curai-text-white curai-bg-transparent curai-p-0"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="curai-w-6 curai-h-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
      </svg >
    </button >

  )
}

export default ChevronDown;